/* Konteo — « Trouvez votre piquant » (ADR 0008). Konteo-owned engine, no framework.
   Data: konteo-quiz.json (questions, copy) and konteo-quiz-data.json (products, recipes). */
(function () {
  'use strict';

  var root = document.querySelector('[data-konteo-quiz]');
  if (!root) return;
  var screenEl = root.querySelector('[data-screen]');

  var Q = null; // questions and copy
  var D = null; // products and recipes
  var state = { screen: 'intro', step: 0, answers: [null, null], heat: 2, pending: null, added: {} };

  // ---------------------------------------------------------------- helpers
  function h(tag, attrs, children) {
    var el = document.createElement(tag);
    if (attrs) Object.keys(attrs).forEach(function (k) {
      if (k === 'class') el.className = attrs[k];
      else if (k === 'html') el.innerHTML = attrs[k];
      else if (k.indexOf('on') === 0) el.addEventListener(k.slice(2), attrs[k]);
      else if (attrs[k] !== null && attrs[k] !== undefined && attrs[k] !== false) el.setAttribute(k, attrs[k] === true ? '' : attrs[k]);
    });
    (children || []).forEach(function (c) {
      if (c === null || c === undefined || c === false) return;
      el.appendChild(typeof c === 'string' ? document.createTextNode(c) : c);
    });
    return el;
  }
  function money(n) {
    var cents = Math.round(n * 100);
    var fmt = root.getAttribute('data-money-format') || '€{{amount}}';
    var amount = (cents / 100).toFixed(2).replace('.', ',');
    return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, amount).replace(/<[^>]+>/g, '');
  }
  function track(name, data) {
    try { if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) window.Shopify.analytics.publish(name, data || {}); } catch (e) { /* no analytics */ }
  }
  // Keeps the question in view without jumping: scrolls only when the top of the quiz is
  // hidden, and stops just under the header so the start of the page stays reachable.
  function scrollTop() {
    var header = document.querySelector('.site-header, header');
    var offset = (header ? header.getBoundingClientRect().height : 0) + 16;
    var top = root.getBoundingClientRect().top;
    if (top >= 0 && top < window.innerHeight * 0.5) return; // already in view: do not move the page
    var y = window.scrollY + top - offset;
    try { window.scrollTo({ top: Math.max(0, y), behavior: reduceMotion() ? 'auto' : 'smooth' }); } catch (e) { window.scrollTo(0, Math.max(0, y)); }
  }
  function reduceMotion() { return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; }
  function label(t) { return (Q.territories[t] || {}).label || t; }
  // The result is addressable through a versioned token that carries the result itself
  // (territory, heat, usage, product handles), not the answers: a shared link still shows the
  // same trio after the questions or the weights change. The payload is base64url encoded so
  // the link reads as an opaque code:
  //   1.engourdissant.2.poisson_volaille.timut-bio+poivre-vert+poivre-rouge  ->  #p=MS5lbmdvdXJk...
  function encode(text) { return btoa(text).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, ''); }
  function decode(code) { return atob(code.replace(/-/g, '+').replace(/_/g, '/')); }
  function resultUrl(withResult) {
    var base = location.pathname + location.search;
    if (!withResult) return base;
    var r = compute();
    var parts = [Q.version || 1, r.dominant, state.heat, r.usage || '-', r.trio.map(function (p) { return p.handle; }).join('+')];
    return base + '#p=' + encode(parts.join('.'));
  }
  function readHash() {
    var code = location.hash.match(/#p=([A-Za-z0-9_-]+)/);
    if (!code) return null;
    var text;
    try { text = decode(code[1]); } catch (e) { return null; }
    var m = text.match(/^(\d+)\.([a-z_]+)\.(\d)\.([a-z_-]+)\.([a-z0-9+-]+)$/i);
    if (!m) return null;
    return { version: Number(m[1]), territory: m[2], heat: Math.min(5, Math.max(1, Number(m[3]))), usage: m[4] === '-' ? null : m[4], handles: m[5].split('+') };
  }
  function toast(text) {
    var el = h('div', { class: 'konteo-quiz__toast', role: 'status' }, [text]);
    document.body.appendChild(el);
    setTimeout(function () { el.remove(); }, 2200);
  }

  // ---------------------------------------------------------------- engine
  function compute() {
    if (state.shared) return sharedResult();
    var e = Q.engine;
    var scores = {};
    var usage = null;
    state.answers.forEach(function (a, i) {
      var opt = a === null ? null : Q.questions[i].options[a];
      if (!opt) return;
      if (opt.usage) usage = opt.usage;
      Object.keys(opt.weights).forEach(function (k) { scores[k] = (scores[k] || 0) + opt.weights[k]; });
    });
    var pref = state.heat;
    var scored = D.products
      .filter(function (p) { return p.available !== false; })
      .map(function (p) {
        var s = (scores[p.territory] || 0) + 0.5 * (scores[p.territory_2] || 0);
        if (usage && p.usages.indexOf(usage) !== -1) s += e.usage_bonus;
        s -= e.heat_penalty * Math.abs(p.heat - pref);
        return { p: p, score: s };
      })
      .sort(function (a, b) { return b.score - a.score; });
    var trio = [], used = {}, names = {};
    for (var i = 0; i < scored.length && trio.length < e.trio_size; i++) {
      var p = scored[i].p;
      if (e.distinct_territories && used[p.territory]) continue;
      if (names[p.title]) continue; // same product in two formats
      trio.push(p); used[p.territory] = true; names[p.title] = true;
    }
    var ranked = Object.keys(scores).sort(function (a, b) { return scores[b] - scores[a]; });
    var dominant = ranked[0] || (trio[0] && trio[0].territory) || 'fruite';
    var explore = scored.map(function (x) { return x.p; })
      .filter(function (p) { return trio.indexOf(p) === -1 && !names[p.title] && p.territory !== 'intense'; })
      .filter(function (p, i, arr) { return arr.findIndex(function (q) { return q.title === p.title; }) === i; })
      .slice(0, e.explore_size);
    return { scores: scores, trio: trio, dominant: dominant, usage: usage, explore: explore, recipe: pickRecipe(trio, dominant) };
  }
  // A result opened from a shared link: the products named in the link, in their order.
  function sharedResult() {
    var s = state.shared;
    var trio = s.handles.map(function (h) { return D.products.find(function (p) { return p.handle === h; }); }).filter(Boolean);
    var scores = {}; scores[s.territory] = 1;
    var explore = D.products.filter(function (p) { return trio.indexOf(p) === -1 && p.territory === s.territory; }).slice(0, Q.engine.explore_size);
    return { scores: scores, trio: trio, dominant: s.territory, usage: s.usage, explore: explore, recipe: pickRecipe(trio, s.territory) };
  }
  function pickRecipe(trio, dominant) {
    var ids = trio.map(function (p) { return p.id; });
    var pool = D.recipes.filter(function (r) { return r.status === 'published'; });
    if (!pool.length) pool = D.recipes; // development: drafts are allowed until recipes are published
    var byMain = pool.filter(function (r) { return ids.indexOf(r.main_product) !== -1; });
    var byAny = pool.filter(function (r) { return r.products.some(function (id) { return ids.indexOf(id) !== -1; }); });
    var byTerritory = pool.filter(function (r) {
      return r.products.some(function (id) { var p = D.products.find(function (x) { return x.id === id; }); return p && p.territory === dominant; });
    });
    return byMain[0] || byAny[0] || byTerritory[0] || null;
  }

  // ---------------------------------------------------------------- cart
  function addToCart(items, btn) {
    if (btn) { btn.disabled = true; }
    var body = { items: items.map(function (v) { return { id: v, quantity: 1 }; }), sections: 'cart-ajax' };
    return fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
    }).then(function (r) { return r.json(); }).then(function (data) {
      if (data.status && data.status >= 400) throw new Error(data.description || data.message || 'cart');
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', { bubbles: true, detail: { product: data, addToCartBtn: btn || null } }));
      items.forEach(function (v) { state.added[v] = true; });
      track('quiz_add_to_cart', { source: 'quiz', items: items.length });
      render();
    }).catch(function () {
      toast(Q.ui.cart_error);
      if (btn) btn.disabled = false;
    });
  }

  // ---------------------------------------------------------------- screens
  function intro() {
    var c = Q.intro;
    return h('div', { class: 'konteo-quiz__intro' }, [
      h('div', null, [
        h('div', { class: 'konteo-quiz__eyebrow' }, [c.eyebrow]),
        h('h1', { class: 'konteo-quiz__title' }, [c.title]),
        h('p', { class: 'konteo-quiz__text' }, [c.text]),
        h('button', { class: 'konteo-quiz__btn konteo-quiz__btn--brand', type: 'button', onclick: function () { state.screen = 'quiz'; state.step = 0; track('quiz_start', { quiz_key: 'piquant_v1' }); render(); scrollTop(); } }, [c.button]),
      ]),
      wheel()
    ]);
  }

  // ---------------------------------------------------------------- wheel
  // The intro shows the nine families as a wheel, after the Comptoir's own pepper flavour
  // wheel « Les Saveurs Poivrées ». One family is lit at a time, with its phrase and three
  // of its pots: a preview of what the quiz gives. It turns by itself, stops under the pointer,
  // and stays on a family the visitor clicks. No auto-turn under prefers-reduced-motion.
  var wheelTimer = null;
  function svg(tag, attrs, children) {
    var el = document.createElementNS('http://www.w3.org/2000/svg', tag);
    if (attrs) Object.keys(attrs).forEach(function (k) {
      if (k.indexOf('on') === 0) el.addEventListener(k.slice(2), attrs[k]);
      else if (attrs[k] !== null && attrs[k] !== undefined && attrs[k] !== false) el.setAttribute(k, attrs[k]);
    });
    (children || []).forEach(function (c) { if (c) el.appendChild(typeof c === 'string' ? document.createTextNode(c) : c); });
    return el;
  }
  function potsOf(t) {
    var list = D.products.filter(function (p) { return p.territory === t && p.image; });
    list.sort(function (a, b) { return (b.available ? 1 : 0) - (a.available ? 1 : 0); });
    return list.slice(0, 3);
  }
  function thumb(url, w) { return url.indexOf('?') === -1 ? url + '?width=' + w : url + '&width=' + w; }
  function wheel() {
    var keys = Q.intro.wheel || Object.keys(Q.territories);
    var n = keys.length, CX = 220, CY = 190, R = 130, r = 96, LR = R + 18;
    var current = 0, held = false;
    var toRad = function (deg) { return (deg - 90) * Math.PI / 180; };
    var pt = function (radius, deg) { return [CX + radius * Math.cos(toRad(deg)), CY + radius * Math.sin(toRad(deg))]; };
    var segs = [], labels = [];
    keys.forEach(function (k, i) {
      var a0 = i * 360 / n, a1 = (i + 1) * 360 / n, mid = (a0 + a1) / 2;
      var o0 = pt(R, a0), o1 = pt(R, a1), i0 = pt(r, a0), i1 = pt(r, a1);
      var d = 'M' + o0.join(',') + ' A' + R + ',' + R + ' 0 0 1 ' + o1.join(',') + ' L' + i1.join(',') + ' A' + r + ',' + r + ' 0 0 0 ' + i0.join(',') + ' Z';
      var lift = pt(6, mid);
      var seg = svg('path', { d: d, class: 'konteo-quiz__seg', 'data-t': k, role: 'button', tabindex: '0', 'aria-label': label(k), 'aria-pressed': 'false',
        style: '--kq-lift:' + (lift[0] - CX).toFixed(1) + 'px,' + (lift[1] - CY).toFixed(1) + 'px',
        onclick: function () { held = true; show(i); track('quiz_wheel', { quiz_key: 'piquant_v1', territory: k }); },
        onkeydown: function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); held = true; show(i); } } });
      var lp = pt(LR, mid), cos = Math.cos(toRad(mid));
      var anchor = cos > 0.3 ? 'start' : cos < -0.3 ? 'end' : 'middle';
      var dy = Math.sin(toRad(mid)) > 0.8 ? 12 : Math.sin(toRad(mid)) < -0.8 ? -4 : 4;
      labels.push(svg('text', { x: lp[0].toFixed(1), y: (lp[1] + dy).toFixed(1), 'text-anchor': anchor, class: 'konteo-quiz__seg-label', 'aria-hidden': 'true' }, [label(k)]));
      segs.push(seg);
    });
    // A needle on the inner edge sweeps to the lit family, always clockwise when the wheel turns by
    // itself; a thin ring inside takes the family's colour so the centre reads with its quartier.
    var needleAngle = 0;
    var needle = svg('g', { class: 'konteo-quiz__needle', 'aria-hidden': 'true' }, [
      svg('path', { d: 'M' + CX + ',' + (CY - r + 1) + ' L' + (CX - 4) + ',' + (CY - r + 9) + ' L' + (CX + 4) + ',' + (CY - r + 9) + ' Z' })
    ]);
    var ring = svg('circle', { cx: CX, cy: CY, r: r - 14, class: 'konteo-quiz__ring', 'aria-hidden': 'true' });
    var name = h('div', { class: 'konteo-quiz__wheel-name' });
    var phrase = h('div', { class: 'konteo-quiz__wheel-phrase' });
    var pots = h('div', { class: 'konteo-quiz__pots' });
    var core = h('div', { class: 'konteo-quiz__wheel-core' }, [name, phrase]);
    var centre = h('div', { class: 'konteo-quiz__wheel-centre' }, [core]);
    function show(i) {
      current = i;
      var k = keys[i];
      segs.forEach(function (sg, j) { sg.classList.toggle('is-lit', j === i); sg.setAttribute('aria-pressed', j === i ? 'true' : 'false'); });
      labels.forEach(function (l, j) { l.classList.toggle('is-lit', j === i); });
      var target = (i + 0.5) * 360 / n;
      var delta = ((target - (needleAngle % 360)) % 360 + 360) % 360;
      if (held && delta > 180) delta -= 360; // a click takes the short way, the auto-turn always goes clockwise
      needleAngle += delta;
      needle.style.transform = 'rotate(' + needleAngle + 'deg)';
      ring.style.stroke = getComputedStyle(segs[i]).fill;
      [core, pots].forEach(function (el) { el.classList.remove('kq-swap'); void el.offsetWidth; el.classList.add('kq-swap'); });
      name.textContent = label(k);
      phrase.textContent = (Q.territories[k] || {}).phrase || '';
      pots.innerHTML = '';
      potsOf(k).forEach(function (p) {
        pots.appendChild(h('a', { class: 'konteo-quiz__pot', href: p.url, 'aria-label': p.title }, [
          h('img', { src: thumb(p.image, 160), alt: '', width: 64, height: 64, loading: 'lazy' }),
          h('span', null, [p.title.replace(/\s*\(.*?\)\s*/g, ' ').replace(/\s+BIO\b/i, '').trim()])
        ]));
      });
    }
    function tick() { if (!held && !paused) show((current + 1) % n); }
    var paused = false;
    var box = h('div', { class: 'konteo-quiz__wheel', onmouseenter: function () { paused = true; }, onmouseleave: function () { paused = false; }, onfocusin: function () { paused = true; }, onfocusout: function () { paused = false; } }, [
      Q.intro.families ? h('div', { class: 'konteo-quiz__eyebrow konteo-quiz__wheel-eyebrow' }, [Q.intro.families]) : null,
      h('div', { class: 'konteo-quiz__wheel-stage' }, [
        svg('svg', { viewBox: '0 0 440 380', class: 'konteo-quiz__wheel-svg', 'aria-label': Q.ui.wheel_aria }, segs.concat(labels, [ring, needle])),
        centre
      ]),
      pots
    ]);
    show(0);
    if (wheelTimer) clearInterval(wheelTimer);
    if (!reduceMotion()) wheelTimer = setInterval(tick, 3600);
    return box;
  }

  function bar(stepIndex, backFn) {
    return h('div', { class: 'konteo-quiz__bar' }, [
      h('button', { class: 'konteo-quiz__back', type: 'button', onclick: backFn }, [Q.ui.back]),
      h('div', { class: 'konteo-quiz__progress', 'aria-label': Q.ui.question_aria.replace('{n}', stepIndex + 1) }, [0, 1, 2].map(function (i) { return h('span', { class: i <= stepIndex ? 'is-done' : '' }); })),
      h('span', null, ['0' + (stepIndex + 1) + ' / 03'])
    ]);
  }

  function question() {
    var i = state.step;
    var q = Q.questions[i];
    var back = function () { if (i === 0) state.screen = 'intro'; else state.step = i - 1; state.pending = null; render(); };
    if (q.key === 'heat') return heatScreen(q, back);
    return h('div', null, [
      bar(i, back),
      h('h2', { class: 'konteo-quiz__title' }, [q.title]),
      q.sub ? h('p', { class: 'konteo-quiz__text' }, [q.sub]) : null,
      h('div', { class: 'konteo-quiz__options', role: 'group' }, q.options.map(function (o, idx) {
        var picked = state.pending === idx, dim = state.pending !== null && !picked;
        return h('button', {
          'data-stagger': true,
          class: 'konteo-quiz__option' + (picked ? ' is-picked' : '') + (dim ? ' is-dim' : ''), type: 'button',
          onclick: function () {
            if (state.pending !== null) return;
            state.answers[i] = idx; state.pending = idx; render();
            track('quiz_step', { quiz_key: 'piquant_v1', step: i + 1 });
            setTimeout(function () { state.pending = null; state.step = i + 1; render(); scrollTop(); }, 380);
          }
        }, [h('span', { class: 'konteo-quiz__option-label' }, [o.label]), h('span', { class: 'konteo-quiz__option-hint' }, [o.hint])]);
      }))
    ]);
  }

  function heatScreen(q, back) {
    var cur = q.scale.find(function (s) { return s.value === state.heat; }) || q.scale[1];
    return h('div', null, [
      bar(2, back),
      h('h2', { class: 'konteo-quiz__title' }, [q.title]),
      q.sub ? h('p', { class: 'konteo-quiz__text' }, [q.sub]) : null,
      h('div', { class: 'konteo-quiz__heat' }, [
        h('div', { class: 'konteo-quiz__eyebrow' }, [Q.ui.level.replace('{n}', state.heat)]),
        h('div', { class: 'konteo-quiz__heat-label' }, [cur.label]),
        h('p', { class: 'konteo-quiz__heat-hint' }, [cur.hint]),
        h('div', { class: 'konteo-quiz__scale', role: 'group', 'aria-label': Q.ui.scale_aria }, q.scale.map(function (s) {
          return h('button', { type: 'button', 'data-n': s.value, class: s.value <= state.heat ? 'is-on' : '', 'aria-pressed': s.value === state.heat ? 'true' : 'false', 'aria-label': Q.ui.level.replace('{n}', s.value) + ' : ' + s.label, onclick: function () { state.heat = s.value; render(); } });
        })),
        h('div', { class: 'konteo-quiz__scale-ends' }, [h('span', null, [q.scale[0].label]), h('span', null, [q.scale[4].label])]),
        q.hint ? h('p', { class: 'konteo-quiz__scale-help' }, [q.hint]) : null
      ]),
      h('div', { class: 'konteo-quiz__actions' }, [
        h('button', { class: 'konteo-quiz__btn konteo-quiz__btn--brand', type: 'button', onclick: finish }, [Q.ui.see_trio])
      ])
    ]);
  }

  function finish() {
    state.screen = 'computing'; render(); scrollTop();
    setTimeout(function () { root.querySelectorAll('.konteo-quiz__race-bar i').forEach(function (el) { el.style.width = el.getAttribute('data-w'); }); }, 60);
    setTimeout(function () {
      state.screen = 'result';
      var r = compute();
      track('quiz_complete', { quiz_key: 'piquant_v1', territory: r.dominant, heat_max: state.heat });
      history.replaceState(null, '', resultUrl(true));
      render(); scrollTop();
    }, 1700);
  }

  function computing() {
    var r = compute();
    var max = Math.max.apply(null, [1].concat(Object.keys(r.scores).map(function (k) { return r.scores[k]; })));
    return h('div', null, [
      h('div', { class: 'konteo-quiz__eyebrow' }, [Q.ui.computing_eyebrow]),
      Q.ui.computing_title ? h('h2', { class: 'konteo-quiz__title' }, [Q.ui.computing_title]) : null,
      h('div', { class: 'konteo-quiz__race' }, Object.keys(Q.territories).map(function (k) {
        return h('div', { class: 'konteo-quiz__race-row', 'data-stagger': true }, [h('span', null, [Q.territories[k].label]), h('div', { class: 'konteo-quiz__race-bar' }, [h('i', { 'data-w': Math.round(100 * (r.scores[k] || 0) / max) + '%' })])]);
      }))
    ]);
  }

  function heatBar(p) {
    return h('div', { class: 'konteo-quiz__heatbar', 'aria-label': Q.ui.heat_aria.replace('{n}', p.heat) }, [1, 2, 3, 4, 5].map(function (i) { return h('i', { class: i <= p.heat ? 'is-on' : '' }); }).concat([h('span', null, [Q.questions[2].scale[p.heat - 1].label])]));
  }

  function card(p) {
    var added = state.added[p.variant_id];
    return h('article', { class: 'konteo-quiz__card', 'data-stagger': true }, [
      h('div', { class: 'konteo-quiz__card-img' }, [p.image ? h('img', { src: p.image + (p.image.indexOf('?') === -1 ? '?' : '&') + 'width=480', alt: p.title, loading: 'lazy' }) : null]),
      h('div', { class: 'konteo-quiz__card-body' }, [
        h('span', { class: 'konteo-quiz__tag' }, [label(p.territory)]),
        h('h3', { class: 'konteo-quiz__card-title' }, [h('a', { href: p.url }, [p.title])]),
        heatBar(p),
        h('p', { class: 'konteo-quiz__reason' }, [p.reason || '']),
        h('div', { class: 'konteo-quiz__card-foot' }, [
          h('span', { class: 'konteo-quiz__price' }, [money(p.price)]),
          h('button', { class: 'konteo-quiz__btn konteo-quiz__btn--sm' + (added ? ' konteo-quiz__btn--outline' : ''), type: 'button', disabled: added, onclick: function (e) { addToCart([p.variant_id], e.currentTarget); } }, [added ? Q.ui.added : Q.ui.add])
        ])
      ])
    ]);
  }

  function result() {
    var r = compute();
    var dom = Q.territories[r.dominant] || { label: r.dominant, phrase: '' };
    var usagePhrase = Q.usage_phrases[r.usage] || 'ce que vous cuisinez déjà';
    var total = r.trio.reduce(function (s, p) { return s + p.price; }, 0);
    var allAdded = r.trio.every(function (p) { return state.added[p.variant_id]; });
    var shareUrl = location.origin + resultUrl(true);
    var recipe = r.recipe;
    return h('div', null, [
      h('div', { class: 'konteo-quiz__profile' }, [
        h('div', { class: 'konteo-quiz__eyebrow' }, [Q.result.profile_eyebrow]),
        h('h2', { class: 'konteo-quiz__title' }, [dom.label]),
        h('p', null, [dom.phrase + ' ' + Q.result.profile_phrase.replace('{territoire}', dom.label.toLowerCase()).replace('{usage}', usagePhrase)])
      ]),
      h('section', { class: 'konteo-quiz__section' }, [
        h('div', { class: 'konteo-quiz__section-head' }, [h('div', null, [h('h2', { class: 'konteo-quiz__h2' }, [Q.result.trio_title]), Q.result.trio_sub ? h('p', { class: 'konteo-quiz__sub' }, [Q.result.trio_sub]) : null])]),
        h('div', { class: 'konteo-quiz__trio' }, r.trio.map(card)),
        h('div', { class: 'konteo-quiz__all' }, [
          h('span', null, ['Trio ' + dom.label.toLowerCase() + ' · ' + r.trio.length + ' pots']),
          h('strong', null, [money(total)]),
          h('button', { class: 'konteo-quiz__btn konteo-quiz__btn--brand', type: 'button', disabled: allAdded, onclick: function (e) { addToCart(r.trio.map(function (p) { return p.variant_id; }), e.currentTarget); } }, [allAdded ? Q.ui.trio_added : Q.result.add_all])
        ])
      ]),
      recipe ? h('section', { class: 'konteo-quiz__section' }, [
        h('div', { class: 'konteo-quiz__section-head' }, [h('h2', { class: 'konteo-quiz__h2' }, [Q.result.recipe_eyebrow + (recipe.time ? ' · ' + recipe.time + ' min' : '')])]),
        h('div', { class: 'konteo-quiz__recipe' }, [
          h('div', { class: 'konteo-quiz__recipe-img' }, [recipe.image ? h('img', { src: recipe.image, alt: recipe.title }) : null]),
          h('div', { class: 'konteo-quiz__recipe-body' }, [
            h('h3', { class: 'konteo-quiz__card-title', style: 'font-size:22px' }, [recipe.title]),
            recipe.portions ? h('div', { class: 'konteo-quiz__eyebrow' }, [recipe.portions]) : null,
            h('p', null, [recipe.intro || '']),
            recipe.url ? h('a', { class: 'konteo-quiz__btn konteo-quiz__btn--outline konteo-quiz__btn--sm', href: recipe.url }, [Q.ui.see_recipe]) : null
          ])
        ])
      ]) : null,
      r.explore.length ? h('section', { class: 'konteo-quiz__section' }, [
        h('div', { class: 'konteo-quiz__section-head' }, [h('h2', { class: 'konteo-quiz__h2' }, [Q.result.explore_title])]),
        h('div', { class: 'konteo-quiz__explore' }, r.explore.map(function (p) {
          return h('a', { class: 'konteo-quiz__mini', href: p.url }, [p.image ? h('img', { src: p.image + (p.image.indexOf('?') === -1 ? '?' : '&') + 'width=120', alt: '' }) : h('span', { class: 'konteo-quiz__card-img' }), h('span', null, [h('span', { class: 'konteo-quiz__tag' }, [label(p.territory)]), h('br'), h('strong', null, [p.title])])]);
        })),
        Q.result.map_url ? h('p', { class: 'konteo-quiz__fine' }, [h('a', { href: Q.result.map_url }, [Q.result.map_link])]) : null
      ]) : null,
      h('section', { class: 'konteo-quiz__section' }, [
        h('div', { class: 'konteo-quiz__section-head' }, [h('h2', { class: 'konteo-quiz__h2' }, [Q.result.share_title])]),
        h('div', { class: 'konteo-quiz__share' }, [
          h('input', { type: 'text', readonly: true, value: shareUrl, 'aria-label': Q.ui.share_input }),
          h('button', { class: 'konteo-quiz__btn konteo-quiz__btn--outline konteo-quiz__btn--sm', type: 'button', onclick: function () { try { navigator.clipboard.writeText(shareUrl); toast(Q.ui.link_copied); } catch (e) { /* no clipboard */ } } }, [Q.ui.copy_link]),
          h('button', { class: 'konteo-quiz__btn konteo-quiz__btn--outline konteo-quiz__btn--sm', type: 'button', onclick: function () { state = { screen: 'intro', step: 0, answers: [null, null], heat: 2, pending: null, added: {}, shared: null }; history.replaceState(null, '', resultUrl(false)); render(); scrollTop(); } }, [Q.result.restart])
        ])
      ])
    ]);
  }

  var lastScreen = null;
  function render() {
    if (wheelTimer) { clearInterval(wheelTimer); wheelTimer = null; }
    screenEl.innerHTML = '';
    var view = state.screen === 'intro' ? intro() : state.screen === 'quiz' ? question() : state.screen === 'computing' ? computing() : result();
    // A new screen slides in; re-rendering the same screen (a click on the scale) does not.
    var key = state.screen + ':' + state.step;
    if (key !== lastScreen) view.classList.add('kq-enter');
    lastScreen = key;
    view.querySelectorAll('[data-stagger]').forEach(function (el, i) { el.style.setProperty('--i', i); });
    screenEl.appendChild(view);
  }

  // ---------------------------------------------------------------- boot
  Promise.all([fetch(root.getAttribute('data-questions')).then(function (r) { return r.json(); }), fetch(root.getAttribute('data-products')).then(function (r) { return r.json(); })])
    .then(function (res) {
      Q = res[0]; D = res[1];
      var shared = readHash();
      if (shared && shared.handles.length) { state.shared = shared; state.heat = shared.heat; state.screen = 'result'; }
      render();
    })
    .catch(function () { screenEl.appendChild(h('p', { class: 'konteo-quiz__error' }, ['Le quiz ne peut pas se charger pour le moment.'])); });
})();
